/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
import React, {
  useRef,
  useCallback,
  useState,
  useEffect,
  useMemo,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { addHours, format, isSameDay, parseISO } from 'date-fns';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';

import { isNull } from 'lodash';
import getValidationErrors from '../../utils/getValidationErrors';

import { useToast } from '../../hooks/toast';
import { useAuth } from '../../hooks/auth';
import { useCategoria } from '../../hooks/categoria';

import SelectSync, { IOption } from '../SelectSync';
import Input from '../Input';
import InputMoney from '../InputMoney';
import InputFake from '../InputFake';
import Excluir from './Excluir';
import Estorno from './Estorno';
import PacienteCabecalho, { IInfoCartao } from '../PacienteCabecalho';

import {
  formatPrice,
  ORIGEM_PAGAMENTO,
  STATUS_AGENDA,
  TIPO_USUARIO,
  updateTimeToNow,
} from '../../utils/funcoes';

import { Container } from './styles';
import api from '../../services/api';

import Modal from '../Modal';
import Desconto, { IDesconto } from './Desconto';
import Loading from '../Loading';
import CancelaBaixa from './CancelaBaixa';
import FormaPagamento from './FormaPagamento';
import { IAgendamentosPaciente, IPaciente } from '../Agendamento';
import getResponseErrors from '../../utils/getResponseErrors';
import ControlesNotaFiscal from '../ControlesNotaFiscal';
import Boleto from './Boleto';
import CopiarAreaTrabalho from '../CopiarAreaTrabalho';
import { useClinica } from '../../hooks/clinica';

interface IPagamento {
  PagCodigo?: number;
  PagCprCodigo?: number;
  PagFormaPag: number;
  PagData: Date;
  PagValor: number;
  PagExcluido?: boolean;
  PagConferido?: boolean;
  PagCanUsuCodigo?: number;
  PagCanMotCodigo?: number;
  PagCanMotivo?: string;
  formaDePagamento?: IFormaPagamento;
  valorFormatado?: string;
}

type PagamentoProps = {
  cprCodigo?: number;
  tipo: string;
  pacCodigo?: number;
  handleFechar(load: boolean): void;
};
export interface IContaPR {
  CprCodigo?: number;
  CprCodOrigem: number;
  CprOrigem: number;
  CprCatCodigo: number;
  CprDataVenc: Date;
  CprValor: number;
  CprNParcela: number;
  CprFormaPag: number;
  CprDataPag?: Date;
  CprReceita: number;
  CprPago: boolean;
  CprExcluida: boolean;
  CprHistorico: string;
  CprValorPag?: number;
  CprConferido?: boolean;
  CprClinica: number;
  CprDataOrigem?: Date;
  CprParcelaAtiva?: boolean;
  CprUsuCodigo: number;
  CprChave?: string;
  pagamento?: IPagamento[];

  CprDataBaixa?: Date;
  CprDesUsuCodigo?: number;
  CprDesMotCodigo?: number;
  CprDesMotivo?: string;
  created_at?: Date;
  updated_at?: Date;
  DataAtualizacaoAgenda?: string;
  usuarioPagamento?: IUsuarioPagamento;
  // pagamentoAgenda?: IAgenda;
}
interface IUsuarioPagamento {
  UsuCodigo: number;
  UsuLogin: string;
  UsuNome: string;
  UsuSenha: string;
}
interface IFormaPagamento {
  BanCodigo: number;
  BanNome: string;
  BanSaldo?: number;
  BanTipo?: boolean;
  BanAtivo?: boolean;
}

interface IFormProps extends FormHandles {
  CprHistorico: string;
  CprCatCodigo: string;
  CprNParcela: string;
  CprValor: number;
  CprDataVenc: Date;
  CprFormaPag: number;
  CprValorPag: number;
  CprDataPag: Date;
  ChkPago: boolean;
}

const Pagamento: React.FC<PagamentoProps> = ({
  cprCodigo,
  tipo,
  pacCodigo,
  handleFechar,
}) => {
  const { user, clinica } = useAuth();
  const { buscaConvenios, convenios, dataHoraServidor } = useClinica();
  const { optionCategorias, buscaCategoria } = useCategoria();

  const [contaPRSelecionada, setContaPRSelecionada] = useState<
    IContaPR | undefined
  >(undefined);

  const [pagamentosRealizados, setPagamentosRealizados] = useState<
    IPagamento[]
  >([]);

  const [pagamentosAlterados, setPagamentosAlterados] = useState<IPagamento[]>(
    [],
  );
  const [paciente, setPaciente] = useState<IPaciente | undefined>(undefined);
  const [agendamento, setAgendamento] = useState<
    IAgendamentosPaciente | undefined
  >(undefined);
  const [infoCartao, setInfoCartao] = useState<IInfoCartao>({
    possuiCartao: false,
  });
  const [dadosBaixa, setDadosBaixa] = useState<
    { nome?: string; data?: string; alteracao?: string } | undefined
  >(undefined);

  const [descontoAplicado, setDescontoAplicado] = useState<IDesconto>({
    UsuCodigo: 0,
    UsuNome: '',
    descricao: '',
    login: '',
    motivo: 0,
    valor: '0',
  });

  const [loading, setLoading] = useState(false);
  const [mensagemPermissaoAdmin, setMensagemPermissaoAdmin] = useState('');
  const [nomeCategoria, setNomeCategoria] = useState('');
  const [showModalExcluir, setShowModalExcluir] = useState(false);
  const [showModalDesconto, setShowModalDesconto] = useState(false);
  const [showModalCancelaBaixa, setShowModalCancelaBaixa] = useState(false);
  const [showModalFormaPagamento, setShowModalFormaPagamento] = useState(false);
  const [showModalEstorno, setShowModalEstorno] = useState(false);
  const [ehExame, setEhExame] = useState(false);

  const formRefPagamento = useRef<IFormProps>(null);

  const { addToast } = useToast();

  const [optionsCategoria, setOptionsCategoria] = useState<IOption[]>([]);

  const ehOutrasReceitas = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.OUTRAS_RECEITAS;
  }, [tipo]);

  const ehConsulta = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.CONSULTAS;
  }, [tipo]);

  const ehDespesa = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.DESPESA;
  }, [tipo]);
  const ehTroco = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.TROCO;
  }, [tipo]);
  const ehSangria = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.SANGRIA;
  }, [tipo]);

  const pagamentosAsaas = useMemo(() => {
    return pagamentosRealizados.find(pg =>
      pg.formaDePagamento?.BanNome.includes('asaas'),
    );
  }, [pagamentosRealizados]);

  const ehCartaoSaude = useMemo(() => {
    return Number(tipo) === ORIGEM_PAGAMENTO.CARTAO;
  }, [tipo]);

  const estaConferido = useMemo(() => {
    return contaPRSelecionada?.CprConferido;
  }, [contaPRSelecionada]);

  const ehNovo = useMemo(() => {
    return !cprCodigo;
  }, [cprCodigo]);

  const medicoAtendePeloSistema = useMemo(() => {
    return agendamento?.configuracaoAgenda?.ConAtende === 1;
  }, [agendamento]);

  useEffect(() => {
    async function Busca(): Promise<void> {
      await buscaConvenios();
    }
    if (agendamento && agendamento.AgeConvCodigo > 0) Busca();
  }, [buscaConvenios, agendamento]);

  const convenioSelecionado = useMemo(() => {
    return convenios.find(
      conv => conv.ConvCodigo === agendamento?.AgeConvCodigo,
    );
  }, [convenios, agendamento?.AgeConvCodigo]);

  const ehConvenio = useMemo(() => {
    return agendamento && agendamento.AgeConvCodigo > 0 && convenioSelecionado;
  }, [agendamento, convenioSelecionado]);

  const pagouHoje = useMemo(() => {
    return (
      contaPRSelecionada?.CprDataPag &&
      isSameDay(
        parseISO(contaPRSelecionada.CprDataPag.toString()),
        new Date(dataHoraServidor.toString()),
      )
    );
  }, [contaPRSelecionada?.CprDataPag, dataHoraServidor]);

  const ehConsultaDoDia = useMemo(() => {
    return (
      !agendamento ||
      isSameDay(
        parseISO(agendamento.AgeInicio.toString()),
        new Date(dataHoraServidor.toString()),
      )
    );
  }, [agendamento, dataHoraServidor]);

  useEffect(() => {
    if (!optionCategorias || Object.keys(optionCategorias).length === 0)
      buscaCategoria();
  }, [buscaCategoria, optionCategorias]);

  useEffect(() => {
    async function loadOptionsCategoria(): Promise<void> {
      try {
        if (Number(tipo) === ORIGEM_PAGAMENTO.DESPESA) {
          setOptionsCategoria(optionCategorias.despesa);
          return;
        }
        if (Number(tipo) === ORIGEM_PAGAMENTO.OUTRAS_RECEITAS) {
          setOptionsCategoria(optionCategorias.outrasReceitas);
          return;
        }
        setOptionsCategoria(optionCategorias.receita);
      } catch (error) {
        handleFechar(false);
        addToast({
          title: 'Não foi possível buscar categorias',
          type: 'error',
        });
      }
    }
    if (ehDespesa || ehConsulta || ehCartaoSaude || ehOutrasReceitas) {
      loadOptionsCategoria();
    }
    const opts: IOption[] = [];
    if (ehSangria) {
      opts.push({
        label: 'Sangria',
        value: ORIGEM_PAGAMENTO.SANGRIA.toString(),
      });
      setOptionsCategoria(opts);
      setNomeCategoria('Sangria');
    }
    if (ehTroco) {
      opts.push({ label: 'Troco', value: ORIGEM_PAGAMENTO.TROCO.toString() });
      setOptionsCategoria(opts);
      setNomeCategoria('Troco');
    }
  }, [
    tipo,
    addToast,
    ehSangria,
    ehTroco,
    ehDespesa,
    ehConsulta,
    ehCartaoSaude,
    ehOutrasReceitas,
    handleFechar,
    optionCategorias,
  ]);

  useEffect(() => {
    if (ehNovo) {
      const parcelaVencimento = {
        CprNParcela: '1',
        CprDataVenc: format(
          updateTimeToNow(new Date(dataHoraServidor.toString())),
          'yyyy-MM-dd',
        ),
        CprFormaPag: '9',
        ChkPago: true,
      };
      if (ehSangria) {
        formRefPagamento.current?.setData({
          CprHistorico: `Sangria - ${user.UsuNome}`.toUpperCase(),
          CprCatCodigo: ORIGEM_PAGAMENTO.SANGRIA.toString(),
          ...parcelaVencimento,
        });
        return;
      }
      if (ehTroco) {
        formRefPagamento.current?.setData({
          CprHistorico: `Troco - ${user.UsuNome}`.toUpperCase(),
          CprCatCodigo: ORIGEM_PAGAMENTO.TROCO.toString(),
          ...parcelaVencimento,
        });
        return;
      }
      if (ehDespesa) {
        formRefPagamento.current?.setData({
          CprCatCodigo: ORIGEM_PAGAMENTO.DESPESA.toString(),
          ...parcelaVencimento,
        });
      }
      if (ehOutrasReceitas) {
        formRefPagamento.current?.setData({
          ...parcelaVencimento,
        });
      }
    }
  }, [
    user.UsuNome,
    ehSangria,
    ehTroco,
    ehNovo,
    ehDespesa,
    ehOutrasReceitas,
    dataHoraServidor,
  ]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);

      let contaPrSelecionada: any;
      try {
        if (Number(tipo) === ORIGEM_PAGAMENTO.CONSULTAS) {
          const responsePaciente = await api.get(
            `/agendamentos/${cprCodigo}/pagamento`,
          );

          setEhExame(
            responsePaciente.data.procedimentos[0].ProCodigoAlvaro || false,
          );

          contaPrSelecionada = responsePaciente.data.pagamento;
          setPaciente({
            ...responsePaciente.data.paciente,
            avatar_url: responsePaciente.data.paciente.avatar_url
              ? responsePaciente.data.paciente.avatar_url
              : '',
          });
          setAgendamento(responsePaciente.data);

          const { possuiCartao } = responsePaciente.data;

          if (possuiCartao && responsePaciente.data.cartao[0])
            setInfoCartao({
              possuiCartao,
              ...responsePaciente.data.cartao[0],
            });

          setContaPRSelecionada(contaPrSelecionada);
        } else {
          const response = await api.get<IContaPR>(
            `/pagamento/${cprCodigo}?CprCodOrigem=${0}`,
          );

          contaPrSelecionada = response.data;
          setContaPRSelecionada(contaPrSelecionada);
        }

        const nome = contaPrSelecionada.usuarioPagamento?.UsuNome;
        const data = contaPrSelecionada.CprDataBaixa
          ? format(
            parseISO(contaPrSelecionada.CprDataBaixa.toString()),
            'dd/MM/yyyy HH:mm',
          )
          : undefined;

        const alteracao = contaPrSelecionada.updated_at
          ? format(
            addHours(parseISO(contaPrSelecionada.updated_at.toString()), -3),
            'dd/MM/yyyy HH:mm',
          )
          : undefined;

        setDadosBaixa({ nome, data, alteracao });
        const pagamentos: IPagamento[] = contaPrSelecionada.pagamento
          ?.filter((pag: any) => pag.PagExcluido === false)
          .map((pag: any) => {
            return {
              ...pag,
              valorFormatado: formatPrice(pag.PagValor),
            };
          });

        if (pagamentos && pagamentos.length > 0)
          setPagamentosRealizados(pagamentos);
        const categ = optionsCategoria.find(
          cat => cat.value === contaPrSelecionada.CprCatCodigo.toString(),
        );

        if (categ) setNomeCategoria(categ.label);
        formRefPagamento.current?.setData({
          ...contaPrSelecionada,
          CprCatCodigo: contaPrSelecionada.CprCatCodigo.toString(),
          CprFormaPag: contaPrSelecionada.CprFormaPag.toString(),
          CprDataVenc: format(
            parseISO(contaPrSelecionada.CprDataVenc.toString()),
            'yyyy-MM-dd',
          ),
          CprDataPag: contaPrSelecionada.CprDataPag
            ? format(
              parseISO(contaPrSelecionada.CprDataPag.toString()),
              'yyyy-MM-dd',
            )
            : format(
              updateTimeToNow(new Date(dataHoraServidor.toString())),
              'yyyy-MM-dd',
            ),
        });

        if (contaPrSelecionada.CprPago) {
          const desconto =
            contaPrSelecionada.CprValor - (contaPrSelecionada.CprValorPag || 0);
          if (desconto > 0)
            setDescontoAplicado({
              valor: desconto.toString(),
              UsuCodigo: Number(contaPrSelecionada.CprDesUsuCodigo || 0),
              UsuNome: '',
              descricao: contaPrSelecionada.CprDesMotivo || '',
              login: '',
              motivo: Number(contaPrSelecionada.CprDesMotCodigo || 0),
            });
        }
      } catch (error) {
        handleFechar(false);
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar registro de pagamento',
          type: 'error',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }
    if (!ehNovo && optionsCategoria && optionsCategoria.length > 0) loadDados();
  }, [
    ehNovo,
    addToast,
    cprCodigo,
    optionsCategoria,
    setLoading,
    handleFechar,
    tipo,
    pacCodigo,
    dataHoraServidor,
  ]);

  const estaPago = useMemo(() => {
    return contaPRSelecionada?.CprPago;
  }, [contaPRSelecionada?.CprPago]);

  const totalDesconto = useMemo(() => {
    return {
      valor: Number(descontoAplicado.valor),
      valorFormatado: formatPrice(-1 * Number(descontoAplicado.valor)),
    };
  }, [descontoAplicado.valor]);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => { }, []);

  const validaDados = useCallback(async (dadosForm): Promise<boolean> => {
    try {
      formRefPagamento.current?.setErrors({});

      const schemaPadrao = Yup.object().shape({
        CprCatCodigo: Yup.number()
          .min(1, 'Selecione uma Categoria')
          .typeError('Selecione uma categoria')
          .required('Categoria requerido'),
        CprDataVenc: Yup.date().required(),
        CprValorPag: Yup.number()
          .typeError('Valor incorreto')
          .required('Valor requerido'),
        CprValor: Yup.number()
          .typeError('digite um número válido')
          .required('Valor requerido'),
        CprNParcela: Yup.number()
          .typeError('Número de parcela')
          .required('Valor requerido'),
        CprHistorico: Yup.string().required(),
      });

      await schemaPadrao.validate(dadosForm, {
        abortEarly: false,
      });
      return true;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefPagamento.current?.setErrors(errors);
      }
      return false;
    }
  }, []);

  const total = useMemo(() => {
    const valor = parseFloat(
      pagamentosRealizados
        .reduce((tot, pag) => {
          return tot + Number(pag.PagValor);
        }, 0)
        .toFixed(2),
    );
    return {
      valor,
      valorFormatado: formatPrice(valor),
    };
  }, [pagamentosRealizados]);

  const pegaValor = useCallback((): number | undefined => {
    return formRefPagamento.current?.getFieldValue('CprValor');
  }, []);

  const handleSalvar = useCallback(async () => {
    if (formRefPagamento.current) {
      const {
        CprCatCodigo,
        CprDataVenc,
        CprValor,
        CprNParcela,
        CprHistorico,
      } = formRefPagamento.current.getData();

      const CprDataPag = updateTimeToNow(new Date(dataHoraServidor.toString()));

      const dataHoraVenc = parseISO(
        `${CprDataVenc} ${format(CprDataPag, 'HH:mm')}`,
      );

      let CprFormaPag = 9;
      let CprValorPag = CprValor;

      let CprDataBaixa: Date | undefined = CprDataPag;

      let pags = [
        {
          PagData: CprDataPag,
          PagFormaPag: CprFormaPag,
          PagValor: CprValor,
        },
      ];

      if (pagamentosRealizados.length > 0) {
        CprFormaPag = pagamentosRealizados[0].PagFormaPag;
        pags = pagamentosRealizados.map(pag => {
          return {
            PagData: CprDataPag,
            PagFormaPag: pag.PagFormaPag,
            PagValor: pag.PagValor,
          };
        });
      } else if (ehDespesa || ehOutrasReceitas) {
        CprValorPag = 0;
        CprDataBaixa = undefined;
        pags = [];
      }

      const dadosForm: Omit<
        IContaPR,
        | 'CprClinica'
        | 'CprCodOrigem'
        | 'CprConferido'
        | 'CprReceita'
        | 'CprPago'
        | 'CprUsuCodigo'
        | 'CprExcluida'
        | 'CprOrigem'
      > = {
        CprCatCodigo: Number(CprCatCodigo),
        CprFormaPag,
        CprDataVenc: dataHoraVenc,
        CprValorPag,
        CprValor,
        CprNParcela,
        CprHistorico: CprHistorico.toUpperCase(),
        CprDataPag,
        CprDataBaixa,
      };

      if (ehTroco) dadosForm.CprCatCodigo = ORIGEM_PAGAMENTO.TROCO;
      if (ehSangria) dadosForm.CprCatCodigo = ORIGEM_PAGAMENTO.SANGRIA;

      const validado = await validaDados(dadosForm);

      if (!validado) {
        return;
      }

      setLoading(true);
      const camposOriginais = {
        CprCodOrigem: 0,
        CprPago:
          ehSangria ||
          ehTroco ||
          ((ehDespesa || ehOutrasReceitas) && pagamentosRealizados.length > 0),
        CprDataPag:
          (ehDespesa || ehOutrasReceitas) && pagamentosRealizados.length === 0
            ? undefined
            : dadosForm.CprDataPag,
        CprDataBaixa:
          (ehDespesa || ehOutrasReceitas) && pagamentosRealizados.length === 0
            ? undefined
            : dadosForm.CprDataPag,
        pagamento: pags,
      };

      const contaPR: IContaPR = {
        CprClinica: user.UsuClinica,
        CprConferido: false,
        CprReceita:
          ehCartaoSaude || ehConsulta || ehOutrasReceitas ? 1 : Number(tipo),
        CprUsuCodigo: user.UsuCodigo,
        CprExcluida: false,
        CprOrigem: Number(tipo),
        CprDataOrigem: dataHoraVenc,
        ...dadosForm,
        CprDataVenc: dataHoraVenc,
        ...camposOriginais,
      };

      try {
        await api.post(`/pagamento/incluir`, contaPR);
        addToast({
          type: 'success',
          title: 'Salvo com sucesso',
        });
        handleFechar(true);
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        const statusErro = error?.response?.status;
        if (statusErro === 403) {
          // setExibePermissaoAdmin(true);
          setMensagemPermissaoAdmin(mensagemErro);
        }
        addToast({
          type: 'error',
          title: 'Erro ao salvar pagamento',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }
  }, [
    user.UsuClinica,
    user.UsuCodigo,
    addToast,
    ehCartaoSaude,
    ehConsulta,
    validaDados,
    tipo,
    handleFechar,
    setLoading,
    ehSangria,
    ehTroco,
    ehDespesa,
    ehOutrasReceitas,
    pagamentosRealizados,
    dataHoraServidor,
  ]);

  const handleLiberarRecepcao = useCallback(async () => {
    if (!contaPRSelecionada) return;
    setLoading(true);
    try {
      await api.delete(`/liberaragenda/${contaPRSelecionada.CprCodigo}`, {
        data: {
          CprCodOrigem: contaPRSelecionada.CprCodOrigem,
          PagCanUsuNome: user.UsuNome,
          DataAtualizacaoAgenda: contaPRSelecionada.DataAtualizacaoAgenda || '',
        },
      });
      addToast({
        type: 'success',
        title: 'Agenda liberada com sucesso',
      });
      handleFechar(true);
    } catch (error: any) {
      const mensagemErro = getResponseErrors(error);
      const statusErro = error?.response?.status;
      if (statusErro === 403) {
        // setExibePermissaoAdmin(true);
        setMensagemPermissaoAdmin(mensagemErro);
      }
      addToast({
        type: 'error',
        title: 'Erro ao liberar pra recepção',
        description: mensagemErro,
      });
    }
    setLoading(false);
  }, [contaPRSelecionada, addToast, setLoading, handleFechar, user.UsuNome]);

  const handleCancelarAgendamento = useCallback(async () => {
    if (!contaPRSelecionada) return;
    setLoading(true);
    try {
      await api.delete(`/cancelaragenda/${contaPRSelecionada.CprCodigo}`, {
        data: {
          CprCodOrigem: contaPRSelecionada.CprCodOrigem,
          PagCanUsuNome: user.UsuNome,
          DataAtualizacaoAgenda: contaPRSelecionada.DataAtualizacaoAgenda || '',
        },
      });
      addToast({
        type: 'success',
        title: 'Agenda cancelada com sucesso',
      });
      handleFechar(true);
    } catch (error: any) {
      const mensagemErro = getResponseErrors(error);
      const statusErro = error?.response?.status;
      if (statusErro === 403) {
        // setExibePermissaoAdmin(true);
        setMensagemPermissaoAdmin(mensagemErro);
      }
      addToast({
        type: 'error',
        title: 'Erro ao cancelar agenda',
        description: mensagemErro,
      });
    }
    setLoading(false);
  }, [contaPRSelecionada, addToast, setLoading, handleFechar, user.UsuNome]);

  const statusAgenda = useMemo(() => {
    if (!ehConsultaDoDia) return STATUS_AGENDA.PAGAMENTO_ANTECIPADO;
    if (!medicoAtendePeloSistema) return STATUS_AGENDA.ATENDIDO;
    if (medicoAtendePeloSistema) return STATUS_AGENDA.AGUARDANDO_ATENDIMENTO;
    return STATUS_AGENDA.CANCELADO;
  }, [medicoAtendePeloSistema, ehConsultaDoDia]);

  const valoresAdicionados = useCallback(
    (CprValor: number) => {
      if (
        parseFloat((total.valor + totalDesconto.valor).toFixed(2)) !== CprValor
      ) {
        addToast({
          title: 'Confira os valores',
          description:
            'O total de valores informados são diferentes do total da parcela.',
          type: 'error',
        });
        return false;
      }
      return true;
    },
    [addToast, total.valor, totalDesconto.valor],
  );
  const handleConfirmaPagamentoAtendimento = useCallback(async () => {
    if (!contaPRSelecionada) {
      addToast({
        type: 'error',
        title: 'Nenhum registro selecionado',
      });
      return;
    }
    if (formRefPagamento.current) {
      const {
        CprCatCodigo,
        CprFormaPag,
        CprDataVenc,
        CprValor,
        CprNParcela,
        CprHistorico,
        CprDataPag,
      } = formRefPagamento.current.getData();

      const totalBateu = valoresAdicionados(Number(CprValor));

      if (!totalBateu) return;
      setLoading(true);

      const dataHoraVenc = parseISO(
        `${CprDataVenc} ${format(
          updateTimeToNow(new Date(dataHoraServidor.toString())),
          'HH:mm',
        )}`,
      );

      const dadosForm: Omit<
        IContaPR,
        | 'CprClinica'
        | 'CprCodOrigem'
        | 'CprConferido'
        | 'CprReceita'
        | 'CprPago'
        | 'CprUsuCodigo'
        | 'CprExcluida'
        | 'CprOrigem'
      > = {
        CprCatCodigo: Number(CprCatCodigo),
        CprFormaPag,
        CprDataVenc,
        CprValorPag: total.valor,
        CprValor,
        CprNParcela,
        CprHistorico: CprHistorico.toUpperCase(),
        CprDataPag,
      };

      const validado = await validaDados(dadosForm);

      if (!validado) {
        setLoading(false);
        return;
      }

      const desconto =
        descontoAplicado.valor !== '0' && descontoAplicado.valor !== ''
          ? {
            CprDesUsuCodigo: descontoAplicado.UsuCodigo,
            CprDesMotCodigo: descontoAplicado.motivo,
            CprDesMotivo: descontoAplicado.descricao.toUpperCase(),
            CprHistorico: `${dadosForm.CprHistorico.toUpperCase()}`,
          }
          : {};
      // CprHistorico: `${
      //   dadosForm.CprHistorico
      // } Desconto de ${formatPrice(
      //   Number(descontoAplicado.valor),
      // )} liberado pelo usuário ${descontoAplicado.UsuNome}`,

      const dataPagamento = updateTimeToNow(
        new Date(dataHoraServidor.toString()),
      );

      const pagamentos = pagamentosRealizados.map(pag => {
        return {
          PagData: dataPagamento,
          PagFormaPag: pag.PagFormaPag,
          PagValor: pag.PagValor,
        };
      });

      const contaPR: IContaPR = {
        ...contaPRSelecionada,
        CprCodOrigem: contaPRSelecionada?.CprCodOrigem || 0,
        CprDataVenc: contaPRSelecionada?.CprDataVenc || dataHoraVenc,
        CprReceita: contaPRSelecionada?.CprReceita === 1 ? 1 : 0,
        CprClinica: user.UsuClinica,
        CprConferido: false,
        CprUsuCodigo: user.UsuCodigo,
        CprOrigem: Number(tipo),
        CprDataOrigem: dataHoraVenc,
        CprFormaPag: pagamentos[0]?.PagFormaPag || 9,
        CprValorPag: total.valor,
        CprHistorico: CprHistorico.toUpperCase(),
        CprValor,
        CprCatCodigo,
        CprNParcela,

        CprExcluida: false,
        CprPago: true,
        CprDataPag: dataPagamento,
        pagamento:
          pagamentos.length > 0
            ? pagamentos
            : [
              {
                PagData: dataPagamento,
                PagFormaPag: 9,
                PagValor: 0,
              },
            ],
        ...desconto,
        DataAtualizacaoAgenda:
          ehDespesa || ehCartaoSaude || ehOutrasReceitas
            ? ''
            : contaPRSelecionada.DataAtualizacaoAgenda || '',
      };

      // delete contaPR.pagamentoAgenda;
      delete contaPR.CprDataBaixa;
      delete contaPR.updated_at;
      delete contaPR.usuarioPagamento;

      const HisLog = ` <b>Usuário:</b> ${user.UsuNome} <br />Pagamento${statusAgenda === STATUS_AGENDA.PAGAMENTO_ANTECIPADO ? 'Antecipado' : ''
        }  realizado, encaminhado para consulta.<br> ${CprHistorico}`;

      const dados = {
        ...contaPR,
        HisLog:
          ehDespesa || ehCartaoSaude || ehOutrasReceitas ? undefined : HisLog,
        statusAgenda:
          ehDespesa || ehCartaoSaude || ehOutrasReceitas
            ? undefined
            : statusAgenda,
        AgeMedUsuCodigo:
          statusAgenda === STATUS_AGENDA.ATENDIDO && !medicoAtendePeloSistema
            ? agendamento?.AgeMedUsuCodigo
            : undefined,
      };

      try {
        await api.post(
          `/caixa/confirmaPagamento/${contaPRSelecionada.CprCodigo}`,
          dados,
        );

        addToast({
          type: 'success',
          title: 'Salvo com sucesso',
        });
        handleFechar(true);
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        const statusErro = error?.response?.status;
        if (statusErro === 403) {
          // setExibePermissaoAdmin(true);
          setMensagemPermissaoAdmin(mensagemErro);
        }
        addToast({
          type: 'error',
          title: 'Erro ao salvar pagamento',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }
  }, [
    user.UsuClinica,
    user.UsuCodigo,
    addToast,
    validaDados,
    tipo,
    handleFechar,
    contaPRSelecionada,
    setLoading,
    total.valor,
    valoresAdicionados,
    pagamentosRealizados,
    descontoAplicado,
    statusAgenda,
    user.UsuNome,
    ehCartaoSaude,
    ehDespesa,
    ehOutrasReceitas,
    medicoAtendePeloSistema,
    agendamento?.AgeMedUsuCodigo,
    dataHoraServidor,
  ]);

  const handleSalvaDesconto = useCallback(data => {
    setDescontoAplicado(data);
    setShowModalDesconto(false);
  }, []);

  const handleCancelarBaixa = useCallback(async () => {
    if (estaConferido) {
      addToast({
        type: 'error',
        title: 'Este pagamento já foi conferido.',
      });
      return;
    }
    setShowModalCancelaBaixa(true);
  }, [estaConferido, addToast]);

  // console.log(
  //   !isNull(contaPRSelecionada?.CprUsuCodigo),
  //   contaPRSelecionada?.CprUsuCodigo !== 1,
  // );
  // console.log(
  //   (pagouHoje || user.UsuCodigo === 1) &&
  //     agendamento?.AgeStatus !== STATUS_AGENDA.ESTORNO &&
  //     ((agendamento?.AgeStatus === STATUS_AGENDA.ATENDIDO && ehExame) ||
  //       ehCartaoSaude),
  // );

  return (
    <>
      {showModalExcluir && (
        <Modal
          show={showModalExcluir}
          titulo="Excluir"
          handleFecharModal={() => setShowModalExcluir(false)}
          large={false}
        >
          {cprCodigo && (
            <Excluir
              cprCodigo={cprCodigo}
              handleFechar={() => handleFechar(true)}
            />
          )}
        </Modal>
      )}
      {showModalCancelaBaixa && (
        <Modal
          show={showModalCancelaBaixa}
          titulo="Cancelar Baixa"
          handleFecharModal={() => setShowModalCancelaBaixa(false)}
          large={false}
        >
          {cprCodigo && !ehTroco && !ehSangria && (
            <CancelaBaixa
              cprCodigo={cprCodigo}
              dataAtualizacaoAgenda={
                contaPRSelecionada?.DataAtualizacaoAgenda || ''
              }
              ehDespesaOuOutrasReceitas={ehDespesa || ehOutrasReceitas}
              handleFechar={() => handleFechar(true)}
            />
          )}
        </Modal>
      )}
      {showModalEstorno && (
        <Modal
          show={showModalEstorno}
          titulo="Estorno"
          handleFecharModal={() => setShowModalEstorno(false)}
          large={false}
        >
          {cprCodigo && contaPRSelecionada?.DataAtualizacaoAgenda && (
            <Estorno
              cprCodigo={cprCodigo}
              dataAtualizacaoAgenda={contaPRSelecionada.DataAtualizacaoAgenda}
              handleFechar={() => handleFechar(true)}
            />
          )}
        </Modal>
      )}
      {showModalDesconto && (
        <Modal
          show={showModalDesconto}
          titulo="Desconto"
          handleFecharModal={() => setShowModalDesconto(false)}
          large={false}
        >
          {cprCodigo && (
            <Desconto
              valorParcela={
                contaPRSelecionada ? contaPRSelecionada.CprValor : 0
              }
              handleFechar={() => setShowModalDesconto(false)}
              handleSalvar={handleSalvaDesconto}
              desconto={descontoAplicado}
            />
          )}
        </Modal>
      )}

      {showModalFormaPagamento && (
        <Modal
          show={showModalFormaPagamento}
          titulo="Alterar Forma de Pagamento"
          handleFecharModal={() => setShowModalFormaPagamento(false)}
          large
        >
          {cprCodigo && (
            <FormaPagamento
              CprValor={contaPRSelecionada?.CprValor || 0}
              cprCodigo={contaPRSelecionada?.CprCodigo || 0}
              ehSangria={false}
              ehTroco={false}
              estaPago={false}
              ehAlteracao
              ehDespesaOuOutrasReceitas={ehDespesa || ehOutrasReceitas}
              descontoAplicado={descontoAplicado}
              pagamentosRealizados={pagamentosAlterados}
              handleAddedPagamento={setPagamentosAlterados}
              handleAddedDesconto={setDescontoAplicado}
              handleFechar={() => {
                setShowModalFormaPagamento(false);
                handleFechar(true);
                setPagamentosAlterados([]);
              }}
              pegaValor={pegaValor}
            />
          )}
        </Modal>
      )}
      <Container>
        {loading && <Loading backgroundBlack={false} />}

        <div
          className={`${ehSangria ||
            ehDespesa ||
            ehOutrasReceitas ||
            ehTroco ||
            ehCartaoSaude
            ? 'd-none'
            : ''
            }`}
        >
          <Row
            className={`no-gutters ${estaPago && !medicoAtendePeloSistema && ehConsultaDoDia
              ? ''
              : 'd-none'
              }`}
          >
            <Col md="8" lg="8" className="pr-2">
              &nbsp;
            </Col>
            <Col
              md="4"
              lg="4"
              className="d-flex justify-content-between align-items-center p-1 pr-2"
            >
              <a
                key="prontuario1"
                href={`impressaodocumento/${contaPRSelecionada?.CprCodOrigem}/prontuarioimpresso`}
                target="_blank"
                className="btn btn-sm btn-success"
                rel="noreferrer"
              >
                Prontuario
              </a>
              <a
                key="prontuario2"
                href={`impressaodocumento/${contaPRSelecionada?.CprCodOrigem}/pedidoexame`}
                target="_blank"
                className="btn btn-sm btn-success"
                rel="noreferrer"
              >
                Pedido Exame
              </a>
            </Col>
          </Row>
          <Row noGutters>
            <Col
              md="12"
              lg="12"
              className={`pr-2 ${agendamento ? '' : 'd-none'}`}
            >
              {paciente && (
                <PacienteCabecalho
                  paciente={paciente}
                  pacienteID={pacCodigo}
                  exibeEditar
                  cartao={infoCartao}
                  exibeInfoCartao
                />
              )}
            </Col>
          </Row>
          <Row
            noGutters
            className={`${agendamento?.AgeObs && agendamento?.AgeObs !== '' ? '' : 'd-none'
              }`}
          >
            <Col md="12" lg="12" className="py-2">
              <div id="LitObservacao">
                <b>Observação:</b> {agendamento?.AgeObs}{' '}
              </div>
            </Col>
          </Row>
        </div>
        <Form
          ref={formRefPagamento}
          // initialData={{ CprValorPag: '' }}
          onSubmit={handleOnChangeVazio}
        >
          <Row noGutters>
            <Col md="12" lg="12" className="form-group pr-2">
              <Input
                name="CprHistorico"
                label="Histórico"
                disabled={!ehDespesa && !ehOutrasReceitas}
              />
            </Col>
          </Row>
          <Row noGutters>
            <Col
              md="4"
              lg="4"
              style={{ zIndex: 4 }}
              className={`form-group pr-2 ${(ehDespesa || ehOutrasReceitas) && ehNovo ? '' : 'd-none'
                }`}
            >
              <SelectSync
                name="CprCatCodigo"
                label="Categoria"
                placeholder="Selecione"
                isClearable={false}
                handleSelectChange={handleOnChangeVazio}
                options={optionsCategoria || { label: '', value: '' }}
              />
            </Col>
            <Col
              md="4"
              lg="4"
              className={`form-group pr-2 ${ehNovo && !ehTroco && !ehSangria ? 'd-none' : ''
                }`}
            >
              <InputFake label="Categoria" disabled value={nomeCategoria} />
            </Col>
            <Col md="2" lg="2" className="form-group pr-2">
              <Input name="CprNParcela" label="Parcela" disabled />
            </Col>
            <Col md="3" lg="3" className="form-group pr-2">
              <InputMoney
                label="Valor"
                name="CprValor"
                autoComplete="nope"
                placeholder="Valor"
                disabled={!ehNovo}
              />
            </Col>
            <Col md="3" lg="3" className="form-group pr-2">
              <Input
                label="Vencimento"
                name="CprDataVenc"
                type="date"
                disabled={!((ehDespesa || ehOutrasReceitas) && !estaPago)}
              />
            </Col>
          </Row>
        </Form>
        <Row className={`no-gutters ${ehSangria || ehTroco ? 'd-none' : ''}`}>
          <Col md="12" lg="12" className="form-group pr-2">
            {!ehSangria && !ehTroco && (
              <FormaPagamento
                CprValor={contaPRSelecionada?.CprValor || 0}
                cprCodigo={contaPRSelecionada?.CprCodigo || 0}
                dadosBaixa={dadosBaixa}
                ehSangria={ehSangria}
                estaPago={estaPago || false}
                ehTroco={ehTroco}
                ehDespesaOuOutrasReceitas={ehDespesa || ehOutrasReceitas}
                handleAddedPagamento={setPagamentosRealizados}
                handleAddedDesconto={setDescontoAplicado}
                pagamentosRealizados={pagamentosRealizados}
                descontoAplicado={descontoAplicado}
                handleFechar={() => setShowModalFormaPagamento(false)}
                pegaValor={pegaValor}
                EhConvenio={
                  ehConvenio &&
                  convenioSelecionado &&
                  !convenioSelecionado.ConvPagaCaixa
                }
              />
            )}
          </Col>
        </Row>

        <Row className="align-items-center border-top p-1">
          <Col md="12">
            <Container
              className={`light-grey text-left pt-3 ${user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA ? 'd-none' : ''
                }`}
            >
              <>
                <Button
                  type="button"
                  variant="info"
                  style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                  size="sm"
                  className={ehNovo ? 'btn btn-sm btn-info mx-2' : 'd-none'}
                  onClick={handleSalvar}
                >
                  Salvar
                </Button>
                <Button
                  type="button"
                  variant="info"
                  style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                  size="sm"
                  className={
                    ehConsulta && !estaPago
                      ? 'btn btn-sm btn-info mx-2'
                      : 'd-none'
                  }
                  onClick={handleLiberarRecepcao}
                >
                  Liberar para Recepção
                </Button>
                <Button
                  type="button"
                  variant="outline-danger"
                  style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                  size="sm"
                  className="d-none"
                  // className={
                  // ehConsulta &&
                  // !estaPago &&
                  // (ehConsultaDoDia || user.UsuCodigo === 1)
                  //   ? 'btn btn-sm btn-outline-danger mx-2'
                  //   : 'd-none'
                  // }
                  onClick={handleCancelarAgendamento}
                >
                  Cancelar Agendamento
                </Button>

                <Button
                  type="button"
                  variant="danger"
                  style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                  size="sm"
                  className={
                    !ehTroco &&
                      !ehSangria &&
                      estaPago &&
                      !pagamentosAsaas &&
                      !isNull(contaPRSelecionada?.CprUsuCodigo) &&
                      (pagouHoje || user.UsuCodigo === 1) &&
                      agendamento?.AgeStatus !== STATUS_AGENDA.ESTORNO &&
                      ((agendamento?.AgeStatus === STATUS_AGENDA.ATENDIDO &&
                        ehExame) ||
                        ehCartaoSaude)
                      ? 'btn btn-sm btn-danger mx-2'
                      : 'd-none'
                  }
                  onClick={handleCancelarBaixa}
                >
                  Cancela Baixa
                </Button>

                <Button
                  type="button"
                  variant="outline-danger"
                  style={{
                    paddingTop: '0.1rem',
                    paddingBottom: '0.1rem',
                    marginRight: '10px',
                  }}
                  size="sm"
                  className={
                    !ehTroco &&
                      !ehSangria &&
                      estaPago &&
                      !isNull(contaPRSelecionada?.CprUsuCodigo) &&
                      !pagamentosAsaas &&
                      contaPRSelecionada?.CprUsuCodigo !== 1 &&
                      (pagouHoje || user.UsuCodigo === 1) &&
                      agendamento?.AgeStatus !== STATUS_AGENDA.ESTORNO
                      ? 'btn btn-sm btn-outline-danger mx-2'
                      : 'd-none'
                  }
                  onClick={() => setShowModalFormaPagamento(true)}
                >
                  Alterar Pagamento
                </Button>

                <Button
                  type="button"
                  variant="success"
                  style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                  size="sm"
                  className={
                    !ehTroco && !ehSangria && !estaPago && !ehNovo
                      ? 'btn btn-sm btn-success mx-2'
                      : 'd-none'
                  }
                  onClick={handleConfirmaPagamentoAtendimento}
                >
                  {`Confirmar ${ehDespesa ||
                    ehOutrasReceitas ||
                    ehCartaoSaude ||
                    !ehConsultaDoDia
                    ? 'Pagamento'
                    : 'Atendimento'
                    }`}
                </Button>

                <Button
                  type="button"
                  variant="danger"
                  style={{ paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
                  size="sm"
                  className={
                    !ehNovo &&
                      !ehCartaoSaude &&
                      !ehConsulta &&
                      (pagouHoje || user.UsuCodigo === 1)
                      ? 'btn btn-sm btn-danger mx-2'
                      : 'd-none'
                  }
                  onClick={() => setShowModalExcluir(true)}
                >
                  Excluir
                </Button>

                <Button
                  type="button"
                  variant="outline-danger"
                  style={{
                    paddingTop: '0.1rem',
                    paddingBottom: '0.1rem',
                    marginLeft: '10px',
                    marginRight: '10px',
                  }}
                  size="sm"
                  className={
                    ehConsulta &&
                      estaPago &&
                      !isNull(contaPRSelecionada?.CprUsuCodigo) &&
                      !pagamentosAsaas &&
                      contaPRSelecionada?.CprUsuCodigo !== 1 &&
                      agendamento?.AgeStatus !== STATUS_AGENDA.ESTORNO
                      ? 'btn btn-sm btn-outline-danger mx-2'
                      : 'd-none'
                  }
                  onClick={() => setShowModalEstorno(true)}
                >
                  Estorno Atendimento
                </Button>
                {cprCodigo &&
                  estaPago &&
                  ((ehCartaoSaude && clinica.CliEmiteNFCartao) ||
                    ehConsulta) && (
                    <ControlesNotaFiscal cprCodigo={cprCodigo} />
                  )}
                {cprCodigo &&
                  contaPRSelecionada &&
                  !estaPago &&
                  clinica.ConfigBoleto?.Emite && (
                    <>
                      <div className="d-flex justify-content-end">
                        <Boleto
                          cprCodigo={cprCodigo}
                          contaPR={contaPRSelecionada}
                        />
                      </div>
                    </>
                  )}
              </>
            </Container>
          </Col>
        </Row>
        <Row className="align-items-center p-1">
          <Col md="12">
            <Container
              className={`light-grey text-left pt-3 ${ehCartaoSaude &&
                contaPRSelecionada?.CprChave &&
                !contaPRSelecionada?.CprPago &&
                clinica.ConfigBoleto?.EmiteOnLine &&
                process.env.REACT_APP_URL_SITE &&
                contaPRSelecionada?.CprValor >= 5 &&
                !contaPRSelecionada?.CprHistorico.includes('ADESÃO')
                ? ''
                : 'd-none'
                }`}
            >
              <CopiarAreaTrabalho
                texto={`${process.env.REACT_APP_URL_SITE}/cartao/pagamento/${contaPRSelecionada?.CprChave}`}
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Pagamento;
